export default __webpack_public_path__ + "static/pig01-43d7ddaf3de4c15f778560c533339e51.png";